import React from "react";
import "./HeavyDutyConveyorChain.css";
import heavyimg from "./heavy.jpg";

const HeavyDutyConveyorChain = () => {
  return (
    <div className="main-heavy">
      <div className="second-heavy">
        <div className="heavy">
          <p>Heavy Duty Conveyor Chain</p>
          <div>
            <p className="heav2">
              Swajit Engineering Pvt.Ltd.> Heavy Duty Conveyor Chain
            </p>
          </div>
        </div>
        <div className="duty">
          <h3 className="hd">
            Leading & Heavy-Duty Conveyor Chain Manufacturers & Exporters in
            India
          </h3>
          <p>
            We at Swajit engineering Pvt ltd are leading one of the{" "}
            <b>
              {" "}
              Leading & Heavy Duty Conveyor Chain Manufacturers & exporters in
              Aurangabad, Maharashtra India.
            </b>{" "}
            We offer a comprehensive range of conveyor chains for transferring
            heavy-duty loads.
          </p>
          <div className="heavy-chain">
            <img src={heavyimg} alt="img"></img>

            <div className="heavy-chain1">
              <div className="heavy-chain2">
                <p>
                  Heavy Duty or leading conveyor Chain is widely used for
                  machines and equipment that are working under very tough load
                  and impact conditions like earth moving equipment,
                  construction, steel industry, etc. These chains can carry
                  heavy loads easily and move quickly. Our conveyor chains are
                  not only delivered at the time but also meet verified
                  specifications at the client end.
                </p>
                <p>
                  The best Leading & Heavy-duty Conveyor Chain Manufacturers &
                  Exporters in India offers the highest series of chains in
                  several sizes, shapes, and specifications for the industry.
                  These chains are made up of superior materials, all required
                  components and tools of the chain are strong and heavy
                  strength in accordance with specifications. They are designed
                  and fabricated with the finest machining processes, and built
                  precisely to accurate dimensions that ensure sustainable long
                  product life and reliable performance.
                </p>
                <p>
                  According to international standards and norms, we are
                  producing a wide range of heavy-duty conveyor chains with the
                  latest technology to meet customer’s expectations. It is
                  making our organization a trusted and reliable <b> Heavy-duty
                  Conveyor chain manufacturer </b> in the market.
                </p>
                <p>Contact us on 9922941689 or Email marketing@swajit.com.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeavyDutyConveyorChain;
